import axios from 'axios';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useNotificationStore } from '../../../stores/notificationStore';

const ResetPassword = ({ user }) => {
	const { showSuccess, showError } = useNotificationStore();
	const [password1, setPassword1] = useState('');
	const [password2, setPassword2] = useState('');

	const handleChangePassword = async (event) => {
		event.preventDefault();
		// TODO validation
		try {
			await axios.put(`/clients/${user.id}`, {
				password: password1,
			});
			showSuccess('Password changed');
			// clear fields
			setPassword1('');
			setPassword2('');
		} catch (err) {
			showError('Password not changed');
		}
	};

	return (
		<div className="grid grid-cols-1 pt-10 gap-x-8 gap-y-8 md:grid-cols-3">
			<div className="px-4 sm:px-0">
				<h2>Password Reset</h2>
				<p className="mt-1 text-sm leading-6 text-gray-600">
					Reset your password and keep your account secure.
				</p>
			</div>
			<form className="bg-white shadow-sm card ring-1 ring-gray-900/5 md:col-span-2">
				<div className="card-body">
					<div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
						<div className="form-control sm:col-span-3">
							<label htmlFor="password1" className="label label-text">
								New Password
							</label>
							<input
								id="password1"
								name="password1"
								type="password"
								autoComplete="new-password"
								value={password1}
								onChange={({ target }) => setPassword1(target.value)}
								required
								className="input input-sm input-bordered"
							/>
						</div>
						<div className="form-control sm:col-span-3">
							<label htmlFor="password2" className="label label-text">
								Confirm Password
							</label>
							<input
								id="password2"
								name="password2"
								type="password"
								autoComplete="new-password"
								value={password2}
								onChange={({ target }) => setPassword2(target.value)}
								required
								className="input input-sm input-bordered"
							/>
						</div>
					</div>
				</div>
				<div className="justify-end px-8 py-4 border-t card-actions border-gray-900/10">
					{/* <button className="btn btn-ghost btn-sm">Cancel</button> */}
					<button
						className="text-white btn btn-primary btn-sm"
						name="form"
						value="changePassword"
						onClick={handleChangePassword}
					>
						Save
					</button>
				</div>
			</form>
		</div>
	);
};

ResetPassword.propTypes = { user: PropTypes.object.isRequired };

export default ResetPassword;
